import { Text } from '@doordash/design-language'
import * as React from 'react'
import PersonaButton from '../../atoms/persona-button'

import { COUNTRY_SHORTCODES } from '../../../constants'

import t from './strings'

type VerifyIdentityProps = {
  country: string
  dasherId: string
}

export const VerifyIdentity: React.FC<VerifyIdentityProps> = (props) => {
  if (props.country == COUNTRY_SHORTCODES.JP) {
    return (
      <React.Fragment>
        <Text styles={Text.Styles.Bold12}>{t.nextStep().concat(":")}</Text>
        <Text styles={Text.Styles.Bold24}>{t.jpVerifyIdentityWarn()}</Text>
        <Text lineHeight={Text.LineHeights.Medium}>
          {t.jpVerifyIdentityWarnText()}
        </Text>
        <PersonaButton
          text={t.jpVerifyIdentity()}
          dasherId={props.dasherId}
        />
      </React.Fragment>      
    )
  }
  return null
}

export default VerifyIdentity
